import type { CatalogPage } from './catalog-navigation.js'
import type { SortDir } from '../common/sortable-th.js'
export type CatalogSort = 'label' | 'parent' | 'level' | 'theme' | 'position' | 'status' | 'availability' | 'popularity'
export type CatalogSortTerm = `${CatalogSort}:${SortDir}`
export const DEFAULT_CATALOG_SORT: Record<CatalogPage, CatalogSortTerm[]> = {
  programs: ['label:asc'],
  levels: ['parent:asc', 'level:asc'],
  themes: ['parent:asc', 'level:asc', 'position:asc'],
  scenarios: ['parent:asc', 'level:asc', 'theme:asc', 'position:asc'],
  tutors: ['popularity:desc', 'label:asc'],
}
export function catalogSortTerms(page: CatalogPage, params: URLSearchParams): CatalogSortTerm[] {
  const terms = params.getAll('sort').filter(term => page === 'tutors' || !term.startsWith('popularity:'))
  const valid = terms.length > 0 && terms.length <= 6 && terms.every(term => /^(label|parent|level|theme|position|status|availability|popularity):(asc|desc)$/.test(term)) && new Set(terms.map(term => term.split(':')[0])).size === terms.length
  return valid ? terms as CatalogSortTerm[] : DEFAULT_CATALOG_SORT[page]
}
export function changeCatalogSort(terms: CatalogSortTerm[], column: CatalogSort, additive: boolean): CatalogSortTerm[] {
  const index = terms.findIndex(term => term.startsWith(`${column}:`))
  const previous = terms[index]
  if (!additive) return [`${column}:${index === 0 && previous?.endsWith(':asc') ? 'desc' : 'asc'}`]
  if (index < 0) return [...terms, `${column}:asc`]
  if (previous?.endsWith(':desc')) return terms.filter((_, i) => i !== index)
  return terms.map<CatalogSortTerm>((term, i) => i === index ? `${column}:desc` : term)
}
